import { ArrowUpRight, Instagram, Users } from "lucide-react";
import { GOOGLE_FORM_URL, INSTAGRAM_URL } from "@/constants/site";
import { Reveal } from "@/components/landing/Reveal";

export const Community = () => {
  return (
    <section id="community" className="scroll-mt-20 bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-splurge-primary">
            Join the community
          </p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-splurge-ink sm:text-5xl">
            Follow along.{" "}
            <span className="text-splurge-primary">Or build it with us.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          <Reveal>
            <article
              data-testid="community-instagram-card"
              className="relative flex h-full flex-col overflow-hidden rounded-3xl bg-gradient-to-br from-splurge-dark via-splurge-primary to-splurge-dark p-8 text-white sm:p-10"
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -right-8 -top-10 select-none text-[10rem] font-extrabold leading-none text-white/[0.07]"
              >
                @
              </span>
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-white/15 backdrop-blur-sm">
                <Instagram className="h-7 w-7 text-white" aria-hidden="true" />
              </span>
              <h3 className="mt-6 text-2xl font-extrabold tracking-tight sm:text-3xl">
                @splurgefinance
              </h3>
              <p className="mt-3 flex-1 text-base leading-relaxed text-white/75">
                Daily money tips, app updates, and behind-the-scenes from the Splurge team.
                Come say hi in our DMs.
              </p>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="community-instagram-follow"
                aria-label="Follow Splurge Finance on Instagram (opens in a new tab)"
                className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-extrabold text-splurge-dark shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:bg-splurge-lavender active:scale-95"
              >
                Follow on Instagram
                <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
              </a>
            </article>
          </Reveal>

          <Reveal delay={120}>
            <article
              data-testid="community-team-card"
              className="flex h-full flex-col rounded-3xl border border-splurge-lavender bg-splurge-bg p-8 sm:p-10"
            >
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-splurge-lavender">
                <Users className="h-7 w-7 text-splurge-primary" aria-hidden="true" />
              </span>
              <h3 className="mt-6 text-2xl font-extrabold tracking-tight text-splurge-ink sm:text-3xl">
                Join the social media &amp; marketing team
              </h3>
              <p className="mt-3 flex-1 text-base leading-relaxed text-splurge-ink/60">
                Love content, creativity, and student life? We are building the team that takes
                Splurge to every campus in India. Fill in the short form and we will get in
                touch.
              </p>
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="community-apply-button"
                aria-label="Apply to join the Splurge social media and marketing team via Google Form (opens in a new tab)"
                className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-splurge-primary px-6 py-3 text-sm font-bold text-white shadow-lg shadow-splurge-primary/30 transition-all duration-200 hover:-translate-y-0.5 hover:bg-splurge-dark active:scale-95"
              >
                Apply via Google Form
                <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
              </a>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
